'use strict';

module.exports = {
    LANG: 'de-de',
    SIGN: 'Accedi',
    REGISTER: 'Anmelden',
    QUICK_ACCESS: 'Schnellzugriff mit',
    SIGN_JOIN: 'Registrati o diventa membro gratis!',
    NOT_MEMBER: 'Non sei un membro?',
    ALREADY_MEMBER: 'Sei già membro di AliExpress/Alibaba?',
    SLIDE_SUBMIT: 'Zum Überprüfen nach rechts wischen',
    SHOW_ALL: 'Zeigen alle',
    HIDE: 'Verstecken'
};